import { callApi } from "./callApi";
import { EnphaseAssetsResponse } from "src/models/onboardingClientsModel";

export const enphaseAuth = (): Promise<{ targetUrl: string }> => {
  return callApi({
    path: "/api/v1/lead/enphase/auth",
    method: "POST",
  });
};

interface EnphaseAssetsPayload {
  code: string;
}

export const enphaseAssets = ({
  code,
}: EnphaseAssetsPayload): Promise<EnphaseAssetsResponse> => {
  return callApi({
    path: "/api/v1/lead/enphase/start",
    method: "POST",
    payload: {
      code,
    },
  });
};
